import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {openDialog} from "../../slices/dialog";
import {selectSelectedRm, storeSelectedFollower,} from "../../slices/selected";
import {
    gamesWithTargetFromList,
    getAgeFromBirthday,
    hasCompetence,
    hasJob,
    hasLanguage,
    hasQualification,
} from "../../helpers/misc";
import Button from "../../components/Common/Button";
import {MessageToFollowers} from "../../components/Dialog/MessageToFollowers";
import {AddRmGroup} from "../../components/Dialog/RmGroup/AddRmGroup";
import {RenameRmGroup} from "../../components/Dialog/RmGroup/RenameRmGroup";
import {deleteRmGroup, editRmGroupMembers} from "../../api/company/rm";
import {AddToGroup} from "../../components/Dialog/RmGroup/AddToGroup";
import {ConfirmAction} from "../../components/CommonComponents";
import MUIDataTable from "mui-datatables";
import {competences as competencesDataset} from "../../db/datasets/competences";
import {languages as languagesDataset} from "../../db/datasets/languages";
import {qualificationScopes as qualificationsDataset} from "../../db/datasets/qualifications";
import {professionScopes as jobsDataset} from "../../db/datasets/professions";
import {completionWeightedPercentage} from "../../helpers/companyRm";
import {getNameAndSurnameString} from "../../db/models/student/student";
import {MissingType} from "../../db/models/extra";
import {CompanyRmGroupI, RmCompetenceI, RmJobI, RmLanguageI, RmQualificationI,} from "../../db/models/company/rm";
import {FollowerInterface} from "../../db/models/follower";
import {ClipLoader} from "react-spinners";
import {useTranslation} from "react-i18next";
import {getFollowersByRmId} from "../../api/other";
import {ROUTES} from "../../db/models/const";
import {getGamesByRmId} from "../../api/game";
import {CompanyGameInterface} from "../../db/models/company/game";
import CustomMUIDataTable, {SelectedRowsToolbarWithExport} from "../../common/components/Datatable/main";
import {datasetIdToLabel} from "../../common/helpers/dataset";

export const CompanyRmAnalytics = () => {
    const rm = useSelector(selectSelectedRm);
    const pricing = "plan1";
    const [groups, setGroups] = useState<CompanyRmGroupI[]>([]);
    const [followers, setFollowers] = useState<FollowerInterface[]>([]);
    const [selectedUids, setSelectedUids] = useState([]);
    const [rows, setRows] = useState<MissingType>([]);
    const [groupRows, setGroupRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [games, setGames] = useState<CompanyGameInterface[]>([]);
    const [selectedGroup, setSelectedGroup] = useState<CompanyRmGroupI | null>(
        null
    );
    const dispatch = useDispatch();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const {t} = useTranslation();

    useEffect(() => {
        if (!rm || !pricing) return;

        // set rm groups
        const mapGroups = rm?.groups || {};
        const groups: CompanyRmGroupI[] = (
            Object.values(mapGroups) as CompanyRmGroupI[]
        ).sort((a: CompanyRmGroupI, b: CompanyRmGroupI) => {
            if (a.name < b.name) return -1;
            else if (a.name > b.name) return 1;
            else return 0;
        });
        setGroups(groups);

        handleSetColumns();
    }, [rm, pricing]);

    useEffect(() => {
        handleSetColumns();
    }, [t]);

    const handleSetColumns = () => {
        // set table columns
        const columns: MissingType = [
            {
                name: "index",
                label: "ID",
                options: {
                    filter: false,
                    // customBodyRender: (
                    // 	value: MissingType,
                    // 	tableMeta: MissingType,
                    // 	updateValue: MissingType
                    // ) => {
                    // 	return <div style={{ width: "10px" }}>{value}</div>;
                    // },
                    // setCellProps: (value: MissingType) => {
                    // 	return {style: {fontSize: "1.2rem", width: "20px"}};
                    // },
                    // setCellHeaderProps: (value: MissingType) => {
                    // 	return {style: {fontSize: "1.2rem"}};
                    // },
                },
            },
            {
                name: "uid",
                label: "Uid",
                options: {
                    display: false,
                    filter: false,
                    searchable: false,
                    viewColumns: false,
                },
            },
            {
                name: "email",
                label: "Email",
                options: {
                    display: false,
                    searchable: false,
                    viewColumns: false,
                },
            },
            {
                name: "name",
                label: t("company_rm_analytics_table_nameHeader"),
                options: {
                    // display: pricing === "free" ? false : true,
                    display: true,
                    // setCellProps: (value: MissingType) => {
                    // 	return {style: {fontSize: "1.2rem"}};
                    // },
                    // setCellHeaderProps: (value: MissingType) => {
                    // 	return {style: {fontSize: "1.2rem"}};
                    // },
                },
            },
            {
                name: "percentage",
                label: t("company_rm_analytics_table_percentageHeader"),
                options: {
                    filter: false,
                    // setCellProps: (value: MissingType) => {
                    // 	return {style: {fontSize: "1.2rem"}};
                    // },
                    // setCellHeaderProps: (value: MissingType) => {
                    // 	return {style: {fontSize: "1.2rem"}};
                    // },
                },
            },
            {
                name: "age",
                label: t("company_rm_analytics_table_ageHeader"),
                // setCellProps: (value: MissingType) => {
                // 	return {style: {fontSize: "1.2rem"}};
                // },
                // setCellHeaderProps: (value: MissingType) => {
                // 	return {style: {fontSize: "1.2rem"}};
                // },
            },
            {
                name: "city",
                label: t("company_rm_analytics_table_cityHeader"),
            },
            {
                name: "qualifications",
                label: t("company_rm_analytics_table_studyHeader"),
                options: {
                    customBodyRender: (
                        value: MissingType,
                        tableMeta: MissingType,
                        updateValue: MissingType
                    ) => {
                        return <ArrayCell value={value}/>;
                    },
                },
            },
            {
                name: "jobs",
                label: t("company_rm_analytics_table_jobHeader"),
                options: {
                    customBodyRender: (
                        value: MissingType,
                        tableMeta: MissingType,
                        updateValue: MissingType
                    ) => {
                        return <ArrayCell value={value}/>;
                    },
                },
            },
            {
                name: "languages",
                label: t("company_rm_analytics_table_langHeader"),
                options: {
                    customBodyRender: (
                        value: MissingType,
                        tableMeta: MissingType,
                        updateValue: MissingType
                    ) => {
                        return <ArrayCell value={value}/>;
                    },
                },
            },
            {
                name: "competences",
                label: t("company_rm_analytics_table_compHeader"),
                options: {
                    customBodyRender: (
                        value: MissingType,
                        tableMeta: MissingType,
                        updateValue: MissingType
                    ) => {
                        return <ArrayCell value={value}/>;
                    },
                },
            },
        ];
        setColumns(columns);
    };

    useEffect(() => {
        if (!rm) return;
        getGamesByRmId(rm.id).then((games: CompanyGameInterface[]) => setGames(games));
    }, [rm]);

    useEffect(() => {
        if (!rm) {
            history.push(ROUTES.ME);
            return;
        }

        if (!games) return;

        getFollowersByRmId(rm.id)
            .then((followers) => {
                setFollowers(followers);
                setLoading(false);
                const rows = followersToRowsNew(followers);
                setRows(rows);
            })
            .catch(() => setLoading(false));
    }, [rm, games]);

    const followersToRowsNew = (followers: FollowerInterface[]) => {
        const rows = followers.map((f, i) => {
            const rmGroups = Object.values(rm?.groups || {});
            const groupIdsIncludingStudent = [
                ...rmGroups
                    .filter((group: any) =>
                        group.studentIds.find((sId: string) => sId === f.user?.id)
                    )
                    .map((group: any) => group.id),
                "",
            ];
            const targetGames = gamesWithTargetFromList(games, groupIdsIncludingStudent);
            const {optional, mandatory} = completionWeightedPercentage(
                rm,
                f?.cv,
                f?.user,
                targetGames
            );

            const row = {
                uid: f.user?.id,
                email: f.user?.email || null,
                name: getNameAndSurnameString(f.user?.name),
                percentage: Math.round(mandatory + optional),
                age: getAgeFromBirthday(f.user?.birthday),
                city: f.user?.city || "",
                qualifications: (
                    Object.values(rm?.bg?.qualifications || {}) as RmQualificationI[]
                )
                    .filter((q: RmQualificationI) => {
                        const hasQ = hasQualification(f?.cv, q);
                        return hasQ === 2;
                    })
                    .map((q: RmQualificationI) =>
                        ((q.scopeIds || []) as number[])
                            .map((id: number) => {
                                return t(datasetIdToLabel(qualificationsDataset, id)) as string;
                            })
                            .join(" | ")
                    ),
                jobs: (Object.values(rm?.bg?.jobs || {}) as RmJobI[])
                    .filter((j: RmJobI) => hasJob(f?.cv, j) === 2)
                    .map((j: RmJobI) =>
                        ((j.scopeIds || []) as number[])
                            .map((id: number) => t(jobsDataset[id].label))
                            .join(" | ")
                    ),
                languages: (Object.values(rm?.bg?.languages || {}) as RmLanguageI[])
                    .filter((l) => hasLanguage(f?.cv, l) === 2)
                    .map((l) => languagesDataset[l.labelId].label),

                competences: (
                    Object.values(rm?.bg?.competences || {}) as RmCompetenceI[]
                )
                    .filter((c) => hasCompetence(f?.cv, c) === 2)
                    .map((c) => competencesDataset[c.labelId].label),
            };
            return row;
        });

        const sortedRows = rows.sort((a, b) => {
            if (a.percentage < b.percentage) return 1;
            else if (a.percentage > b.percentage) return -1;
            else return 0;
        });

        const sortedRowsPlus = sortedRows.map((row, i) => {
            return {
                ...row,
                index: i + 1,
                percentage: row.percentage + "%"
            };
        });

        return sortedRowsPlus;
    };

    const onSend = () => {
        if (selectedUids.length === 0) return;

        const emails = selectedUids.map(
            (uid) => followers.find((f) => f.user.id === uid)?.user.email
        );

        dispatch(
            openDialog({
                Content: MessageToFollowers,
                title: t("company_rm_analytics_sendMsg_title"),
                props: {
                    emails,
                },
                closable: true,
            })
        );
    };

    const onFollowerClick = (rowData: MissingType, rowMeta: MissingType) => {
        if (!rowData || rowData.length < 2) return;

        // if (pricing === "free") {
        // 	openPremium();
        // 	return;
        // }

        // search follower from followers list by uid
        const studentId = rowData[1];
        const follower = followers.find((f) => f.user.id === studentId);
        if (!follower) return;

        dispatch(storeSelectedFollower({follower}));
        history.push(ROUTES.FOLLOWER);
    };

    const onNewGroup = () => {
        // if (pricing === "free") {
        // 	openPremium();
        // 	return;
        // }
        dispatch(
            openDialog({
                Content: AddRmGroup,
                title: t("company_rm_analytics_addGroup_title"),
                props: {},
                closable: true,
            })
        );
    };

    const onRenameGroup = () => {
        dispatch(
            openDialog({
                Content: RenameRmGroup,
                title: t("company_rm_analytics_editGroup_title"),
                props: {group: selectedGroup},
                closable: true,
            })
        );
    };

    const onAddToGroup = () => {
        if (!selectedUids || selectedUids.length === 0) return;
        dispatch(
            openDialog({
                Content: AddToGroup,
                title: t("company_rm_analytics_addToGroup_title"),
                props: {newStudentIds: selectedUids},
                closable: true,
            })
        );
    };

    const onRemoveFromGroup = () => {
        if (!selectedUids || selectedUids.length === 0 || !selectedGroup) return;

        const leftStudentIds = groupRows
            .filter((row: MissingType) => !selectedUids.includes(row.uid as never))
            .map((row: MissingType) => row.uid as string);

        editRmGroupMembers(rm.id, selectedGroup.id, leftStudentIds);
    };

    const onDeleteGroup = () => {
        if (!selectedGroup) return;
        const action = () =>
            deleteRmGroup(rm.id, selectedGroup.id).then(() => setSelectedGroup(null));

        dispatch(
            openDialog({
                Content: ConfirmAction,
                title: t("company_rm_analytics_removeGroup_title"),
                props: {action},
                closable: true,
            })
        );
    };

    const onRowSelect = (
        currentRowsSelected: MissingType,
        allRowsSelected: MissingType,
        rowsSelected: MissingType
    ) => {
        const selectedUids = rowsSelected.map((i: number) => rows[i]?.uid);
        setSelectedUids(selectedUids);
    };

    const onGroupRowSelect = (
        currentRowsSelected: MissingType,
        allRowsSelected: MissingType,
        rowsSelected: MissingType
    ) => {
        const selectedUids = rowsSelected.map(
            (i: number) => (groupRows[i] as MissingType)?.uid
        );
        setSelectedUids(selectedUids);
    };

    useEffect(() => {
        setSelectedUids([]);
        if (selectedGroup) {
            // get follower of selected group
            const groupRows = [...rows].filter((row, i) =>
                selectedGroup.studentIds.includes(row.uid)
            );
            setGroupRows(groupRows as MissingType);
        }
    }, [selectedGroup]);

    const onSelectGroup = (group: CompanyRmGroupI) => {
        if (!group) return;

        // if (pricing === "free") {
        // 	openPremium();
        // 	return;
        // }

        setSelectedGroup(group);
    };

    return (
        <div className="companyRmAnalytics w-100">
            <div className="bar">
                <div className="bar__left">
                    <button
                        className={`bar__link ${!selectedGroup ? "bar__link--active" : ""}`}
                        onClick={() => setSelectedGroup(null)}
                    >
                        {t("company_rm_analytics_all")}
                    </button>
                    <div className="bar__divider"></div>
                    {groups.map((group) => (
                        <button
                            className={`bar__link ${
                                selectedGroup?.id === group.id ? "bar__link--active" : ""
                            }`}
                            onClick={() => onSelectGroup(group)}
                        >
                            {group.name}
                        </button>
                    ))}
                    {groups.length > 0 && <div className="bar__divider"></div>}
                    <button className="bar__link" onClick={() => onNewGroup()}>
                        {t("company_rm_analytics_newGroupBtn")}
                    </button>
                </div>
                <Button
                    onClick={() => onSend()}
                    // disabled={
                    // 	selectedUids.length === 0 || pricing === "free" ? true : false
                    // }
                    disabled={selectedUids.length === 0}
                >
                    {t("company_rm_analytics_sendMsgBtn")}
                </Button>
            </div>
            <div className="groupOptions">
                {selectedGroup && (
                    <div className="groupOptions__option" onClick={() => onRenameGroup()}>
                        {t("company_rm_analytics_renameGroupBtn")}
                    </div>
                )}
                {selectedUids.length > 0 && !selectedGroup && (
                    <div className="groupOptions__option" onClick={() => onAddToGroup()}>
                        {t("company_rm_analytics_addToGroupBtn")}
                    </div>
                )}
                {selectedUids.length > 0 && selectedGroup && (
                    <div
                        className="groupOptions__option"
                        onClick={() => onRemoveFromGroup()}
                    >
                        {t("company_rm_analytics_removeFromGroupBtn")}
                    </div>
                )}
                {selectedGroup && (
                    <div
                        className="groupOptions__option"
                        id="deleteGroup"
                        onClick={() => onDeleteGroup()}
                    >
                        {t("company_rm_analytics_deleteGroupBtn")}
                    </div>
                )}
            </div>
            <div className="card table">
                {!selectedGroup && (
                    // <MuiThemeProvider theme={getMuiTheme}>
                    <CustomMUIDataTable
                        title={t("company_rm_analytics_followerCount", {
                            count: rows?.length,
                        })}
                        data={rows}
                        columns={columns}
                        options={{
                            filter: true,
                            filterType: "multiselect",
                            responsive: "vertical",
                            tableBodyHeight: "100%",
                            print: false,
                            downloadOptions: {
                                filename: `${rm?.name}.csv`,
                            },
                            fixedHeader: false,
                            filterArrayFullMatch: true,
                            elevation: 0,
                            onRowClick: onFollowerClick,
                            onRowSelectionChange: onRowSelect,
                            customToolbarSelect: (selectedRows, data) =>
                                <SelectedRowsToolbarWithExport
                                    selectedRows={selectedRows}
                                    data={data}
                                    columns={columns}
                                    datatableFileName={`${rm?.name}.csv`}
                                />,
                            // selectableRows: pricing === "free" ? "none" : "multiple",
                            selectableRows: "multiple",
                            textLabels: {
                                body: {
                                    noMatch: loading ? (
                                        <ClipLoader size={20} color={"#7400b8"} loading={true}/>
                                    ) : (
                                        <p>{t("company_rm_analytics_no_followers")}</p>
                                    ),
                                },
                            },
                            rowsPerPage: 15,
                            rowsPerPageOptions: [10, 15, 30],
                        }}
                    />
                    // </MuiThemeProvider>
                )}
                {selectedGroup && (
                    <CustomMUIDataTable
                        title={t("company_rm_analytics_groupFollowerCount", {
                            name: selectedGroup.name,
                            count: groupRows?.length,
                        })}
                        data={groupRows}
                        columns={columns}
                        options={{
                            filter: true,
                            filterType: "multiselect",
                            responsive: "vertical",
                            tableBodyHeight: "100%",
                            print: false,
                            fixedHeader: true,
                            downloadOptions: {
                                filename: `${rm?.name}_${selectedGroup.name.replace(/\s/g,"")}.csv`,
                            },
                            filterArrayFullMatch: true,
                            elevation: 0,
                            onRowClick: onFollowerClick,
                            onRowSelectionChange: onGroupRowSelect,
                            customToolbarSelect: (selectedRows, data) =>
                                <SelectedRowsToolbarWithExport
                                    selectedRows={selectedRows}
                                    data={data}
                                    columns={columns}
                                    datatableFileName={`${rm?.name}_${selectedGroup.name.replace(/\s/g, "")}.csv`}
                                />,
                            // selectableRows: pricing === "free" ? "none" : "multiple",
                            selectableRows: "multiple",
                            textLabels: {
                                body: {
                                    noMatch: loading ? (
                                        <ClipLoader size={20} color={"#7400b8"} loading={true}/>
                                    ) : (
                                        <p>{t("company_rm_analytics_no_followers")}</p>
                                    ),
                                },
                            },
                            rowsPerPage: 20,
                            rowsPerPageOptions: [10, 20, 30],
                        }}
                    />
                )}
            </div>
        </div>
    );
};

interface ArrayCellProps {
    value: MissingType;
}

const ArrayCell: React.FC<ArrayCellProps> = ({value}) => {
    return (
        <div className="arrayCell">
            {value.map((v: MissingType) => (
                <div key={v} className="arrayCell_chip">
                    {v}
                </div>
            ))}
        </div>
    );
};
